// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2VNba","boxTitle":"Qualiphy_boxTitle__3yZBb","box":"Qualiphy_box__3_8BA","toggleWrap":"Qualiphy_toggleWrap__8upn3"};